import { render, staticRenderFns } from "./QRCodeButton.vue?vue&type=template&id=0d805386"
import script from "./QRCodeButton.vue?vue&type=script&lang=js"
export * from "./QRCodeButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports